"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInheritanceClassChain = exports.getInheritanceChain = void 0;
const getInheritanceChain = (instance) => {
    const chain = [];
    let currentCtor = instance.constructor;
    while (currentCtor && currentCtor !== Object && currentCtor !== Function) {
        chain.push(currentCtor.name);
        const parentProto = Object.getPrototypeOf(currentCtor.prototype);
        const parentCtor = parentProto?.constructor;
        if (!parentProto || parentProto === Object.prototype)
            break;
        currentCtor = parentCtor ?? null;
    }
    return {
        parentClassName: chain.length ? chain[chain.length - 1] : null,
        chain,
    };
};
exports.getInheritanceChain = getInheritanceChain;
const getInheritanceClassChain = (instance) => {
    const chain = [];
    let currentCtor = instance.constructor;
    while (currentCtor && currentCtor !== Object && currentCtor !== Function) {
        chain.push(currentCtor);
        const parentProto = Object.getPrototypeOf(currentCtor.prototype);
        const parentCtor = parentProto?.constructor;
        if (!parentProto || parentProto === Object.prototype)
            break;
        currentCtor = parentCtor ?? null;
    }
    return {
        chain,
    };
};
exports.getInheritanceClassChain = getInheritanceClassChain;
